import { useState, useRef } from "react";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { format, parseISO } from "date-fns";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import Box from "@mui/material/Box";
// helpers
import { getMonthInFuture } from "../../common/utils/helpers/getMonthInFuture";
import { getDateFnsLocale } from "../../common/utils/helpers/localeHelpers/getDateFnsLocale";
import { getFormattedDate } from "../../common/utils/helpers/getFormattedDate";

// AppDatePicker for json schema forms

export default function AppDatePicker(props: any) {
  const [selectedDate, setSelectedDate] = useState(parseISO(props.formData));
  const currentDate = new Date();
  const sixMonthInFutureDate = getMonthInFuture(6);
  const inputRef = useRef(null);

  const handleDateChange = (date: any) => {
    setSelectedDate(date);

    props.onChange(getFormattedDate(date));
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={getDateFnsLocale()}>
      <Box>
        <Box className="form-group form-group--vertical date-picker-box">
          <label className="form-group__label form-group__label--white"> {props?.schema?.title} </label>

          <CalendarTodayIcon
            style={{ position: "absolute", right: 10, top: "75%", transform: "translateY(-50%)", cursor: "pointer" }}
            onClick={handleDateChange}
            data-cy="calendar-icon"
          />
          <DatePicker
            minDate={currentDate}
            maxDate={sixMonthInFutureDate}
            value={selectedDate}
            onChange={handleDateChange}
            ref={inputRef.current}
          />
        </Box>
      </Box>
    </LocalizationProvider>
  );
}
